import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { I18n } from 'react-redux-i18n';

import grey from '@material-ui/core/colors/grey';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';

import { EmailValidator } from './../validators';

import { changePass } from '../../redux/actions/authActions';

const styles = {
  checkRemember: {
    style: {
      float: 'left',
      maxWidth: 180,
      paddingTop: 5,
    },
    labelStyle: {
      color: grey[500],
    },
    iconStyle: {
      color: grey[500],
      borderColor: grey[500],
      fill: grey[500],
    }
  },
  loginBtn: {
    float: 'right',
  },
  btn: {
    background: '#4f81e9',
    color: grey[50],
    padding: 7,
    borderRadius: 2,
    margin: 2,
    fontSize: 13,
  },
  btnFacebook: {
    background: '#4f81e9',
  },
  btnGoogle: {
    background: '#e14441',
  },
  btnSpan: {
    marginLeft: 5,
  },
  center: {
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  }
};

const validate = values => {
  const errors = {};
  const requiredFields = ['email', 'password', 'confirmPassword'];
  requiredFields.forEach(field => {

    if (!values[field]) {
      errors[field] = I18n.t('messages.required_field');
    }

    if (!EmailValidator(values.email)) {
      errors.email = I18n.t('messages.invalid_email');
    }

    if (values.password != values.confirmPassword) {
      errors.confirmPassword = I18n.t('messages.password_not_equals');
    }

  });
  return errors
};

const form = reduxForm({
  form: 'RecoveryPassForm',
  destroyOnUnmount: false,
  fields: ['email', 'password', 'confirmPassword'],
  validate
});

const mapStateToProps = state => ({
  loading: state.auth.loading
});

const mapDispatchToProps = {
  changePass,
};

class RecoveryPassForm extends React.Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    changePass: PropTypes.func.isRequired,
    router: PropTypes.any.isRequired
  };

  constructor(props) {

    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleCloseError = this.handleCloseError.bind(this);

    this.state = {
      dialogErrorsOpen: false,
      errors: []
    };

  }

  onSubmit(data) {

    data.code = this.props.location.query.code;

    this.props.changePass(data).then(
      response => {
        this.props.router.replace('/login');
      },
      error => {
        this.setState({
          dialogErrorsOpen: true,
          errors: error.response.data.errors
        })
      }
    );

  }

  handleCloseError(){

    this.setState({
      dialogErrorsOpen: false,
      errors: []
    });

  }

  render() {

    const {handleSubmit, pristine, submitting, valid, loading} = this.props;

    return (
      <div>
        <form>

          <div>
            <Field name="email"
                   component={TextField}
                   hintText={I18n.t('fields.email')}
                   floatingLabelText={I18n.t('fields.email')}
                   fullWidth={true}
                   disabled={loading}/>
          </div>

          <div>
            <Field name="password" type="password"
                   component={TextField}
                   hintText={I18n.t('fields.password')}
                   floatingLabelText={I18n.t('fields.password')}
                   fullWidth={true}
                   disabled={loading}/>
          </div>

          <div>
            <Field name="confirmPassword" type="password"
                   component={TextField}
                   hintText={I18n.t('fields.confirmPassword')}
                   floatingLabelText={I18n.t('fields.confirmPassword')}
                   fullWidth={true}
                   disabled={loading}/>
          </div>

          <div>

            <Button
              label={I18n.t('application.reset_pass')}
              variant="contained"
              primary
              style={styles.loginBtn}
              type="submit"
              onClick={handleSubmit(this.onSubmit)}
              disabled={pristine || submitting || !valid || loading}
            />

          </div>
        </form>

        <Dialog
          title={I18n.t('application.errors_found')}
          open={this.state.dialogErrorsOpen}
          actions={<Button
            label={I18n.t('application.close')}
            primary
            onTouchTap={this.handleCloseError}
          />}
        >

          <List>
            {
              this.state.errors.map((error, index) =>
                <ListItem key={error.key} primaryText={error.value} leftIcon={<MoreVertIcon />} />)
            }
          </List>

        </Dialog>
      </div>
    );

  }

}

export default withRouter(
  form(
    connect(mapStateToProps, mapDispatchToProps)(RecoveryPassForm)
  )
);



// WEBPACK FOOTER //
// ./src/components/auth/RecoveryPassForm.js